module.exports = __webpack_public_path__ + "static/media/PTSans-Bold.7c7b7ca4.ttf";